import { render } from "./manageAccountCreateAndEdit.vue?vue&type=template&id=21ebd27a&scoped=true"
import script from "./manageAccountCreateAndEdit.vue?vue&type=script&lang=js"
export * from "./manageAccountCreateAndEdit.vue?vue&type=script&lang=js"

import "./manageAccountCreateAndEdit.vue?vue&type=style&index=0&id=21ebd27a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ebd27a"]])

export default __exports__